import { inject, Injectable } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ConfirmationDialogComponent } from "../components/confirmation-dialog/confirmation-dialog.component";
import { Observable, from } from "rxjs";

export interface ConfirmationDialogConfig {
  title: string;
  message: string;
  confirmButtonLabel?: string;
  cancelButtonLabel?: string;
  dialogSize?: "sm" | "lg";
}

@Injectable({ providedIn: "root" })
export class ConfirmationDialogService {
  private ngbModalService = inject(NgbModal);

  public showConfirmModal(config: ConfirmationDialogConfig): Observable<boolean> {
    const modalRef = this.ngbModalService.open(ConfirmationDialogComponent, {
      size: config?.dialogSize,
      centered: true,
    });

    modalRef.componentInstance.title = config?.title;
    modalRef.componentInstance.message = config?.message;
    modalRef.componentInstance.confirmButtonLabel = config?.confirmButtonLabel;
    modalRef.componentInstance.cancelButtonLabel = config?.cancelButtonLabel;

    return from(modalRef.result);
  }
}
